import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LegalLayout from '../components/LegalLayout';

const PROVIDER = {
  name: 'HR Aristu, SLU',
  cif: 'B71445308',
  address: 'Calle San Nicolás 68-70, 6º, 31001 Pamplona (Navarra), España',
  email: 'soporte@hraristu.com'
};

const SECTIONS_ES = [
  {
    heading: '1. Identificación del prestador',
    body: [
      `Estos Términos de Servicio regulan el acceso y uso de Regulisto (el "Servicio"), una plataforma de control horario prestada por ${PROVIDER.name}, con CIF ${PROVIDER.cif} y domicilio social en ${PROVIDER.address} (en adelante, "nosotros" o "el Prestador"). Puedes contactarnos en ${PROVIDER.email}.`
    ]
  },
  {
    heading: '2. Objeto del Servicio',
    body: [
      'Regulisto es una aplicación SaaS multiempresa para el registro y control de la jornada laboral conforme al RD-ley 8/2019, que incluye, entre otras funciones: fichajes por kiosko con PIN, código QR o geolocalización con validación de radio; gestión de turnos, vacaciones y ausencias; incidencias sobre fichajes; calendario laboral y festivos; firma digital y hash de verificación en los registros; y exportación de informes en PDF, Excel y CSV.',
      'El Servicio se contrata por una empresa u organización (el "Cliente") a través de la persona que completa el registro, quien declara tener capacidad suficiente para contratar en nombre de dicha empresa.'
    ]
  },
  {
    heading: '3. Registro, prueba gratuita y cuenta',
    body: [
      'El registro crea una cuenta de administrador para la organización del Cliente y activa automáticamente un periodo de prueba gratuito de 14 días, sin necesidad de introducir ningún método de pago. Durante la prueba, el Cliente tiene acceso completo a las funciones del plan seleccionado.',
      'Si al finalizar el periodo de prueba no se ha activado una suscripción de pago, el acceso a las funciones del Servicio quedará suspendido hasta que se contrate un plan; los datos introducidos se conservarán durante un plazo razonable antes de su eliminación definitiva.',
      'El Cliente es responsable de la veracidad de los datos facilitados en el registro, de mantener la confidencialidad de su contraseña y de los PIN de fichaje asignados a sus trabajadores, y de toda actividad realizada desde su cuenta.'
    ]
  },
  {
    heading: '4. Planes, precios y facturación',
    body: [
      'Los planes disponibles y sus precios se muestran en la página de precios y pueden actualizarse en el tiempo; cualquier cambio de precio se comunicará con antelación razonable y no afectará a periodos ya facturados.',
      'Los pagos recurrentes se procesan a través de Stripe, Inc. Regulisto no almacena en ningún momento los datos completos de la tarjeta de pago. Los precios se indican en euros (€) e incluyen o excluyen impuestos según se indique en cada momento en el proceso de pago.',
      'El Cliente puede cancelar su suscripción en cualquier momento desde el portal de facturación (gestionado por Stripe), accesible desde el panel de administración. La cancelación surte efecto al finalizar el periodo ya pagado; no se realizan reembolsos de periodos parciales salvo que la ley aplicable disponga lo contrario.'
    ]
  },
  {
    heading: '5. Protección de datos y encargo de tratamiento',
    body: [
      'El tratamiento de los datos personales del Cliente y de las personas de contacto se rige por nuestra Política de Privacidad.',
      `Respecto a los datos personales de los trabajadores del Cliente que este introduzca en el Servicio (fichajes, geolocalización, turnos, vacaciones, ausencias, etc.), el Cliente actúa como Responsable del Tratamiento y ${PROVIDER.name} como Encargado del Tratamiento, conforme al artículo 28 del RGPD.`,
      <>
        El <Link to="/dpa" className="text-indigo-600 hover:text-indigo-700 underline">Acuerdo de Encargado de Tratamiento (DPA)</Link> queda incorporado por referencia a estos Términos y forma parte integrante de ellos: al aceptar estos Términos de Servicio, aceptas también el DPA, sin necesidad de ningún paso adicional. El Cliente es responsable de contar con base legal suficiente para tratar los datos de sus trabajadores y de informarles adecuadamente.
      </>
    ]
  },
  {
    heading: '6. Obligaciones del Cliente',
    body: [
      {
        list: [
          'Usar el Servicio conforme a la legislación aplicable, en particular la normativa laboral y de protección de datos.',
          'No utilizar el Servicio para introducir datos de categorías especiales innecesarios ni para fines distintos del control horario y la gestión de personal.',
          'Custodiar adecuadamente las credenciales de acceso y los PIN del kiosko de fichaje.',
          'Informar sin demora de cualquier uso no autorizado de su cuenta.'
        ]
      }
    ]
  },
  {
    heading: '7. Disponibilidad y soporte',
    body: [
      'Nos esforzamos por mantener el Servicio disponible de forma continua, si bien puede sufrir interrupciones programadas (mantenimiento) o no programadas. No se garantiza un nivel de servicio (SLA) específico salvo que se pacte expresamente por escrito. El soporte se presta a través del email indicado en el apartado 1.'
    ]
  },
  {
    heading: '8. Propiedad intelectual',
    body: [
      `El software, marca, diseño y código fuente de Regulisto son propiedad de ${PROVIDER.name} o de sus licenciantes. El Cliente conserva la titularidad de los datos que introduce en el Servicio y podrá exportarlos en cualquier momento en los formatos disponibles.`
    ]
  },
  {
    heading: '9. Limitación de responsabilidad',
    body: [
      'El Servicio se presta "tal cual". Salvo dolo o negligencia grave, nuestra responsabilidad total frente al Cliente por cualquier reclamación derivada del uso del Servicio se limita al importe efectivamente pagado por el Cliente en los 12 meses anteriores al hecho causante. No respondemos de daños indirectos, lucro cesante o pérdida de datos derivados de un uso indebido del Servicio o de un incumplimiento por el Cliente de sus obligaciones de custodia de credenciales.'
    ]
  },
  {
    heading: '10. Modificaciones',
    body: [
      'Podemos modificar estos Términos para reflejar cambios legales, de producto o del Servicio. Notificaremos los cambios sustanciales con antelación razonable mediante email o aviso en la aplicación. El uso continuado del Servicio tras la entrada en vigor de los cambios implica su aceptación.'
    ]
  },
  {
    heading: '11. Legislación aplicable y jurisdicción',
    body: [
      'Estos Términos se rigen por la legislación española. Para cualquier controversia, las partes se someten a los Juzgados y Tribunales de Pamplona (Navarra), salvo que la normativa de consumidores y usuarios disponga otro fuero de carácter imperativo.'
    ]
  }
];

const SECTIONS_EN = [
  {
    heading: '1. Service provider',
    body: [
      `These Terms of Service govern access to and use of Regulisto (the "Service"), a workforce time-tracking platform provided by ${PROVIDER.name}, tax ID (CIF) ${PROVIDER.cif}, registered at ${PROVIDER.address}, Spain ("we", "us", or "the Provider"). You can reach us at ${PROVIDER.email}.`
    ]
  },
  {
    heading: '2. What the Service does',
    body: [
      'Regulisto is a multi-tenant SaaS application for recording and managing employee working time in compliance with Spanish labor law (RD-ley 8/2019), including: PIN kiosk, QR code, and GPS-validated clock-ins; shift, vacation, and absence management; clock-in incident correction workflows; a work calendar with holidays; a digital signature and verification hash on every record; and PDF, Excel, and CSV report exports.',
      'The Service is contracted by a company or organization (the "Customer") through the person completing signup, who represents that they are authorized to enter into this agreement on the Customer\'s behalf.'
    ]
  },
  {
    heading: '3. Signup, free trial, and account',
    body: [
      'Signing up creates an administrator account for the Customer\'s organization and automatically starts a 14-day free trial, with no payment method required. During the trial, the Customer has full access to the selected plan\'s features.',
      'If no paid subscription is active when the trial ends, access to the Service\'s features is suspended until a plan is purchased; data already entered is retained for a reasonable period before permanent deletion.',
      'The Customer is responsible for the accuracy of the information provided at signup, for keeping their password and any employee clock-in PINs confidential, and for all activity under their account.'
    ]
  },
  {
    heading: '4. Plans, pricing, and billing',
    body: [
      'Available plans and pricing are shown on the pricing page and may change over time; any price change will be communicated with reasonable notice and will not affect already-billed periods.',
      'Recurring payments are processed through Stripe, Inc. Regulisto never stores full payment card details. Prices are shown in euros (€) and include or exclude tax as indicated during checkout.',
      'The Customer may cancel their subscription at any time from the billing portal (managed by Stripe), accessible from the admin panel. Cancellation takes effect at the end of the already-paid period; no refunds are issued for partial periods unless required by applicable law.'
    ]
  },
  {
    heading: '5. Data protection and data processing',
    body: [
      'Processing of the Customer\'s and its contacts\' personal data is governed by our Privacy Policy.',
      `Regarding personal data of the Customer's own employees entered into the Service (clock-ins, geolocation, shifts, vacations, absences, etc.), the Customer acts as Data Controller and ${PROVIDER.name} as Data Processor, under Article 28 GDPR.`,
      <>
        The <Link to="/dpa" className="text-indigo-600 hover:text-indigo-700 underline">Data Processing Agreement (DPA)</Link> is incorporated by reference into these Terms and forms an integral part of them: by accepting these Terms of Service, you also accept the DPA, with no additional steps required. The Customer is responsible for having a valid legal basis to process its employees' data and for informing them accordingly.
      </>
    ]
  },
  {
    heading: '6. Customer obligations',
    body: [
      {
        list: [
          'Use the Service in compliance with applicable law, in particular labor and data protection regulations.',
          'Not use the Service to enter unnecessary special-category data or for purposes other than time tracking and workforce management.',
          'Safeguard login credentials and clock-in kiosk PINs appropriately.',
          'Promptly report any unauthorized use of their account.'
        ]
      }
    ]
  },
  {
    heading: '7. Availability and support',
    body: [
      'We aim to keep the Service continuously available, though it may experience scheduled (maintenance) or unscheduled interruptions. No specific service level (SLA) is guaranteed unless expressly agreed in writing. Support is provided via the email address listed in section 1.'
    ]
  },
  {
    heading: '8. Intellectual property',
    body: [
      `Regulisto's software, brand, design, and source code are owned by ${PROVIDER.name} or its licensors. The Customer retains ownership of the data it enters into the Service and may export it at any time in the available formats.`
    ]
  },
  {
    heading: '9. Limitation of liability',
    body: [
      'The Service is provided "as is". Except in cases of willful misconduct or gross negligence, our total liability to the Customer for any claim arising from use of the Service is limited to the amount actually paid by the Customer in the 12 months preceding the event giving rise to the claim. We are not liable for indirect damages, lost profits, or data loss resulting from misuse of the Service or the Customer\'s failure to safeguard its credentials.'
    ]
  },
  {
    heading: '10. Changes to these Terms',
    body: [
      'We may update these Terms to reflect legal, product, or Service changes. We will notify material changes with reasonable notice via email or an in-app notice. Continued use of the Service after changes take effect constitutes acceptance.'
    ]
  },
  {
    heading: '11. Governing law and jurisdiction',
    body: [
      'These Terms are governed by Spanish law. Any dispute shall be submitted to the Courts of Pamplona (Navarra), Spain, unless mandatory consumer-protection rules require otherwise.'
    ]
  }
];

const TermsOfService = () => {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <LegalLayout
      title={isEs ? 'Términos de Servicio' : 'Terms of Service'}
      effectiveDate={isEs ? '23 de agosto de 2026' : 'August 23, 2026'}
      sections={isEs ? SECTIONS_ES : SECTIONS_EN}
    />
  );
};

export default TermsOfService;
